import React, { useState } from "react";
import Select from "react-select";

import makeAnimated from "react-select/animated";

var MultiSelector = function MultiSelector(_ref) {
  var options = _ref.options,
      selectedValues = _ref.selectedValues,
      defaultValues = _ref.defaultValues,
      values = _ref.values;

  var animatedComponents = makeAnimated();

  var handleOnChange = function handleOnChange(data) {
    selectedValues(data);
  };
  // Estilo do Seletor
  // Documentação => https://react-select.com/styles
  var customStyles = {
    option: function option(styles, _ref2) {
      var isDisabled = _ref2.isDisabled,
          isFocused = _ref2.isFocused,
          isSelected = _ref2.isSelected;

      return Object.assign({}, styles, {
        border: "1px solid var(--borderDefault)",
        backgroundColor: "var(--backgroundInput)",
        opacity: isDisabled ? null : isSelected ? "0.3" : isFocused ? "0.9" : null,
        color: isDisabled ? "#ccc" : isSelected ? "var(--textDefault)" ? "var(--textDefault)" : "var(--textDefault)" : "var(--textDefault)",
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": Object.assign({}, styles[":active"], {
          backgroundColor: !isDisabled && (isSelected ? "var(--backgroundInput)" : "var(--backgroundInput)")
        })
      });
    },

    menu: function menu(styles) {
      return Object.assign({}, styles, {
        backgroundColor: "var(--backgroundInput)"
      });
    },

    control: function control(styles) {
      return Object.assign({}, styles, {
        color: "var(--textDefault)",
        background: "var(--backgroundInput)",
        borderColor: "var(--borderDefault)"
      });
    },

    multiValue: function multiValue(styles) {
      return Object.assign({}, styles, {
        color: "var(--danger)",
        backgroundColor: "var(--backgroundDefault)",
        maxWidth: "250px"
      });
    },

    valueContainer: function valueContainer(styles) {
      return Object.assign({}, styles, {
        maxHeight: "200px",
        overflow: "auto"
      });
    },

    multiValueLabel: function multiValueLabel(styles) {
      return Object.assign({}, styles, {
        color: "var(--textDefault)"
      });
    }
  };

  return React.createElement(Select, {
    options: options,
    closeMenuOnSelect: false,
    components: animatedComponents,
    placeholder: "Selecione...",
    isMulti: true,
    value: values,
    defaultValue: defaultValues,
    onChange: handleOnChange,
    styles: customStyles
  });
};
export default MultiSelector;